function loadScript(src, callback) {
    var js = document.createElement("script");
    js.src = src;
    js.onload = function () {
        callback();
    };
    js.onerror = function () {
        callback(new Error("Failed to load script " + src));
    };
    js.defer = false;
    js.async = false;
    document.head.appendChild(js);
}

export function load_required_polyfills(callback) {
    const browser_supports_all =
        Element.prototype.closest &&
        Array.prototype.find &&
        Array.prototype.findIndex &&
        Object.assign &&
        NodeList.prototype.forEach &&
        window.IntersectionObserver &&
        window.Promise;

    const features = [
        "Object.assign",
        "Array.prototype.find",
        "Array.prototype.findIndex",
        "Element.prototype.closest",
        "NodeList.prototype.forEach",
        "IntersectionObserver",
        "IntersectionObserverEntry",
        "Promise",
    ];

    if (browser_supports_all) {
        callback();
    } else {
        loadScript("https://polyfill.io/v3/polyfill.min.js?features=" + features.join("%2C"), callback);
    }
}
